import { ServicesFormValues } from '@/components/forms/form-service/ServiceForm.types';
import useGetOrgCheckSchedule from '@/hooks/queries/organization-api/useGetOrgCheckSchedule';
import useGetServiceById from '@/hooks/queries/services-api/useGetServiceById';
import usePatchService from '@/hooks/queries/services-api/usePatchService';
import useGetOrganizationSports from '@/hooks/queries/sports-api/useGetOrganizationSports';
import { getChangedValues } from '@/utils/forms';
import { useParams } from 'react-router-dom';

const useEditService = () => {
  const { id: serviceId } = useParams();
  const {
    data: service,
    isError: isErrorService,
    isLoading: isLoadingService
  } = useGetServiceById(serviceId);
  const {
    data: sport,
    isError: isErrorSport,
    isLoading: isLoadingSport
  } = useGetOrganizationSports();
  const { data: orgCheckSchedule } = useGetOrgCheckSchedule({
    activeDays: service?.activeDays,
    activeMonths: service?.activeMonths
  });
  const { mutate, isPending } = usePatchService();
  const isScheduleConflict = orgCheckSchedule !== null;

  const isError = isErrorService || isErrorSport;
  const isLoading = isLoadingService || isLoadingSport;

  const defaultValues = {
    name: service?.name,
    description: service?.description,
    price: service?.price,
    reservationPct: service?.reservationPct,
    minPreReservationTime: service?.minPreReservationTime,
    sport: service?.sport.id,
    allowPayment: service?.allowPayment,
    visibility: service?.visibility,
    canUpdateReservations: service?.canUpdateReservations,
    minConsumers: service?.minConsumers,
    maxConsumers: service?.maxConsumers,
    minAge: service?.minAge ?? 0,
    maxAge: service?.maxAge ?? 0
  };

  const onSubmit = (data: any) => {
    const onlyChangedData = getChangedValues<Partial<ServicesFormValues>>(
      defaultValues,
      data
    );
    mutate({ payload: onlyChangedData, serviceId: service?.id ?? '' });
  };

  const defaultSchedule = {
    activeDays: service?.activeDays ? JSON.parse(service.activeDays) : [],
    activeMonths: service?.activeMonths ? JSON.parse(service.activeMonths) : []
  };

  return {
    isLoading,
    isError,
    isPending,
    service,
    serviceId,
    sport,
    defaultValues,
    defaultSchedule,
    onSubmit,
    isScheduleConflict
  };
};

export default useEditService;
